import React from 'react';
import { isEmpty, prop } from '../utils/fp';
import { ErrorBoundary } from 'react-error-boundary';
import Typography from '@mui/material/Typography';
import { ID_ERROR_PAGE } from '../css-api';
import { getAsset } from '../lib/settings';
import { fromSearchToState } from '../utils/router';
import { Logo } from '@sis-cc/dotstatsuite-visions/Logo';
import Page from './Page';
import { FormattedMessage } from '../i18n';
import useTheme from '@mui/material/styles/useTheme';

const ThemeLessFallbackComponent = () => <h1>Whoops, something went wrong on our end.</h1>;

const FallbackComponent = () => {
  const theme = useTheme();

  if (!theme || isEmpty(theme)) return <ThemeLessFallbackComponent />;

  // selector are not possible in this component
  const localeId = prop('locale', fromSearchToState(window.location.search));

  const styles = {
    // no theme when final because above theme provider
    backgroundColor: theme?.palette.primary.main,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  };

  return (
    <Page id={ID_ERROR_PAGE} styles={styles}>
      <div style={{ paddingTop: theme ? theme.spacing(10) : 100 }}>
        <Logo logo={getAsset('subheader', localeId)}>
          <Typography variant="h6" color="secondary">
            <FormattedMessage id="de.error.title" />
          </Typography>
        </Logo>
      </div>
    </Page>
  );
};

const FunctionalErrorBoundary = ({ id, children }) => {
  const handleError = (error, info) => {
    // Log error to an external service (ie Sentry)
    console.error(id, error, info); // eslint-disable-line no-console
  };

  const resetError = () => {
    console.log('resetError', id); // eslint-disable-line no-console
    // Reset the state of your app so the error doesn't happen again
    // This could involve resetting some context or state variables
  };

  return (
    <ErrorBoundary
      FallbackComponent={id === 'root' ? ThemeLessFallbackComponent : FallbackComponent}
      onError={handleError}
      onReset={resetError}
    >
      {children}
    </ErrorBoundary>
  );
};

export default FunctionalErrorBoundary;
